"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconButtonStyles = exports.iconButtonSelectedStyles = exports.iconButtonSecondarySkinStyles = exports.iconButtonVariantSkin = exports.iconButtonSizeSkin = void 0;
const lit_1 = require("lit");
const button_styles_1 = require("@/components/common/button/button.styles");
const utils_1 = require("@/utils");
const iconButtonSizeTokens = {
    small: { '--icon-button-size': 'var(--size-24)' },
};
/** 자체 button을 렌더하는 시맨틱 컴포넌트가 크기 단계 하나를 골라 얹는 선언. 얹을 선택자 안에 펼쳐 쓴다. */
const iconButtonSizeSkin = (size) => (0, lit_1.unsafeCSS)((0, utils_1.buildDeclarations)(iconButtonSizeTokens[size]));
exports.iconButtonSizeSkin = iconButtonSizeSkin;
const iconButtonVariantTokens = {
    primary: {
        '--icon-button-background-color': 'var(--primary-color)',
        '--icon-button-text-color': 'var(--foreground-on-primary-color)',
    },
    secondary: {
        '--icon-button-border-radius': 'var(--radius-full)',
        '--icon-button-border': 'var(--border)',
        '--icon-button-background-color': 'var(--material-base-background-color)',
        '--icon-button-backdrop-filter': 'var(--material-base-backdrop-filter)',
        '--icon-button-shadow': 'var(--material-elevated-shadow)',
    },
    ghost: {
        '--icon-button-background-color': 'transparent',
    },
    danger: {
        '--icon-button-background-color': 'var(--danger-color)',
        '--icon-button-text-color': 'var(--foreground-on-primary-color)',
    },
};
/** 자체 button을 렌더하는 시맨틱 컴포넌트가 variant 하나를 골라 얹는 선언. 얹을 선택자 안에 펼쳐 쓴다. */
const iconButtonVariantSkin = (variant) => (0, lit_1.unsafeCSS)((0, utils_1.buildDeclarations)(iconButtonVariantTokens[variant]));
exports.iconButtonVariantSkin = iconButtonVariantSkin;
/**
 * close/more/next/prev/to-top-button처럼 secondary 스킨을 그대로 쓰는 계열이 공유하는 스킨.
 * iconButtonStyles의 기본(tertiary)값 위에 얹어 쓴다.
 */
exports.iconButtonSecondarySkinStyles = (0, lit_1.css) `
  :host {
    ${(0, exports.iconButtonVariantSkin)('secondary')}
  }
`;
/**
 * 누름 상태는 표준 aria-pressed로 표현하므로, 스킨도 해당 attribute selector를 단일 기준으로 둔다.
 * 아이콘 버튼은 아이콘 자체가 채워져 선택을 알리므로 색만 바꾼다.
 */
exports.iconButtonSelectedStyles = (0, lit_1.css) `
  button[aria-pressed='true'] {
    --icon-button-text-color: var(--interaction-selected-foreground-color);
  }
`;
/**
 * icon-button 계열의 기반 스타일.
 * hover·focus·disabled는 자체 button을 렌더하는 파생 컴포넌트가 빠뜨리기 쉬우므로
 * buttonBaseStyles와 같이 interactiveControlStyles를 여기 묶어 함께 내보낸다.
 */
exports.iconButtonStyles = [
    button_styles_1.interactiveControlStyles,
    (0, lit_1.css) `
    :host {
      display: inline-flex;
      --icon-button-size: var(--size-32);
      --icon-button-background-color: var(--background-subtle-color);
      --icon-button-border-radius: var(--radius);
      --icon-button-border: var(--border-transparent);
      --icon-button-text-color: var(--foreground-color);
      --icon-button-shadow: none;
      --icon-button-backdrop-filter: none;
    }

    button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: var(--icon-button-size);
      height: var(--icon-button-size);
      border: var(--icon-button-border);
      border-radius: var(--icon-button-border-radius);

      background: var(--icon-button-background-color);
      box-shadow: var(--icon-button-shadow);
      backdrop-filter: var(--icon-button-backdrop-filter);
      -webkit-backdrop-filter: var(--icon-button-backdrop-filter);
      color: var(--icon-button-text-color);
      font-family: var(--font-family);

      &:hover {
        --icon-button-border: var(--border);
      }
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('variant', iconButtonVariantTokens, 'button'))}

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('size', iconButtonSizeTokens))}
  `,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWNvbi1idXR0b24uc3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaWNvbi1idXR0b24uc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZCQUFvQztBQUlwQyw0RUFBbUY7QUFDbkYsbUNBQXNGO0FBRXRGLE1BQU0sb0JBQW9CLEdBQXVEO0lBQy9FLEtBQUssRUFBRSxFQUFFLG9CQUFvQixFQUFFLGdCQUFnQixFQUFFO0NBQ2xELENBQUE7QUFFRCxxRUFBcUU7QUFDOUQsTUFBTSxrQkFBa0IsR0FBRyxDQUFDLElBQXVDLEVBQUUsRUFBRSxDQUM1RSxJQUFBLGVBQVMsRUFBQyxJQUFBLHlCQUFpQixFQUFDLG9CQUFvQixDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQTtBQUQ3QyxRQUFBLGtCQUFrQixzQkFDMkI7QUFFMUQsTUFBTSx1QkFBdUIsR0FBNEQ7SUFDdkYsT0FBTyxFQUFFO1FBQ1AsZ0NBQWdDLEVBQUUsc0JBQXNCO1FBQ3hELDBCQUEwQixFQUFFLG9DQUFvQztLQUNqRTtJQUNELFNBQVMsRUFBRTtRQUNULDZCQUE2QixFQUFFLG9CQUFvQjtRQUNuRCxzQkFBc0IsRUFBRSxlQUFlO1FBQ3ZDLGdDQUFnQyxFQUFFLHVDQUF1QztRQUN6RSwrQkFBK0IsRUFBRSxzQ0FBc0M7UUFDdkUsc0JBQXNCLEVBQUUsaUNBQWlDO0tBQzFEO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsZ0NBQWdDLEVBQUUsYUFBYTtLQUNoRDtJQUNELE1BQU0sRUFBRTtRQUNOLGdDQUFnQyxFQUFFLHFCQUFxQjtRQUN2RCwwQkFBMEIsRUFBRSxvQ0FBb0M7S0FDakU7Q0FDRixDQUFBO0FBRUQsdUVBQXVFO0FBQ2hFLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxPQUE2QyxFQUFFLEVBQUUsQ0FDckYsSUFBQSxlQUFTLEVBQUMsSUFBQSx5QkFBaUIsRUFBQyx1QkFBdUIsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUE7QUFEbkQsUUFBQSxxQkFBcUIseUJBQzhCO0FBRWhFOzs7R0FHRztBQUNVLFFBQUEsNkJBQTZCLEdBQUcsSUFBQSxTQUFHLEVBQUE7O01BRTFDLElBQUEsNkJBQXFCLEVBQUMsV0FBVyxDQUFDOztDQUV2QyxDQUFBO0FBRUQ7OztHQUdHO0FBQ1UsUUFBQSx3QkFBd0IsR0FBRyxJQUFBLFNBQUcsRUFBQTs7OztDQUkxQyxDQUFBO0FBRUQ7Ozs7R0FJRztBQUNVLFFBQUEsZ0JBQWdCLEdBQUc7SUFDOUIsd0NBQXdCO0lBQ3hCLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUFpQ0MsSUFBQSxlQUFTLEVBQUMsSUFBQSwyQkFBbUIsRUFBQyxTQUFTLEVBQUUsdUJBQXVCLEVBQUUsUUFBUSxDQUFDLENBQUM7O01BRTVFLElBQUEsZUFBUyxFQUFDLElBQUEsMkJBQW1CLEVBQUMsTUFBTSxFQUFFLG9CQUFvQixDQUFDLENBQUM7R0FDL0Q7Q0FDRixDQUFBIn0=